{
  "uplift": {
    "header": "Votre voyage n’est plus admissible au Plan Uplift de paiement par mensualités",
    "message": "Les détails de votre voyage ont changé et votre itinéraire n'est plus admissible au Plan Uplift de paiement par mensualités. S’il s’agit d’une erreur, veuillez contacter votre agent ou lui demander comment votre voyage pourrait être admissible au Plan Uplift de paiement par mensualités."
  },
  "flexpay": {
    "header": "Votre voyage n'est plus admissible à un prêt Flex Pay",
    "message": "Les détails de votre voyage ont changé et votre itinéraire n'est plus admissible à un prêt Flex Pay. S’il s’agit d’une erreur, veuillez contacter votre agent ou demandez comment votre voyage peut être admissible à un prêt."
  }
}
